import openWithFairePath, {
  route as openWithFaireRoute,
} from "@faire/web-api--source/routes/www/open-with-faire";
import openWithFaireAcademyPath, {
  route as openWithFaireAcademyRoute,
} from "@faire/web-api--source/routes/www/open-with-faire/academy";
import { route as openWithFaireAcademyBuyRetailInventoryRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy/buy-retail-inventory";
import { route as openWithFaireAcademyFindRetailSpaceRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy/find-retail-space";
import { route as openWithFaireAcademyFundingLicensingRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy/funding-licensing";
import { route as openWithFaireAcademyLayTheGroundworkRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy/lay-the-groundwork";
import { route as openWithFaireAcademyOrganizeStoreOperationsRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy/organize-store-operations";
import { route as openWithFaireAcademyPromoteYourStoreRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy/promote-your-store";
import { route as openWithFaireAcademyRenovateYourStoreRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy/renovate-your-store";
import { useStrictLocalization } from "@faire/web/common/localization";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { IBreadcrumbOption } from "@faire/web/ui/Breadcrumbs";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useGetOpenWithFaireDesktopBreadcrumbOptions = () => {
  const { pathname } = useLocation();
  const { strictLocalize } = useStrictLocalization();
  return useMemo(() => {
    const openWithFaireLanding: IBreadcrumbOption = {
      label: strictLocalize({
        id: "sox/wR",
        defaultMessage: "Open with Faire",
        description: {
          text: "Name of a program we offer for helping opening retailers to start their business",
          img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
        },
      }),
      path: openWithFairePath(),
    };

    const openWithFaireFaireAcademyLanding: IBreadcrumbOption = {
      label: strictLocalize({
        id: "dpQSIi",
        defaultMessage: "Guides",
        description: {
          text: "Breadcrumb for Open With Faire Academy Guides",
          img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
        },
      }),
      path: openWithFaireAcademyPath(),
    };

    const faireAcademyGuidesBreadcrumbMap: Record<string, IBreadcrumbOption> = {
      [openWithFaireAcademyBuyRetailInventoryRoute]: {
        label: strictLocalize({
          id: "qBRJsq",
          defaultMessage: "Plan & buy inventory",
          description: {
            text: "Breadcrumb for Open With Faire Academy Plan & buy inventory Guide",
            img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
          },
        }),
      },
      [openWithFaireAcademyFindRetailSpaceRoute]: {
        label: strictLocalize({
          id: "BWv+Nm",
          defaultMessage: "Find a space",
          description: {
            text: "Breadcrumb for Open With Faire Academy Find a space Guide",
            img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
          },
        }),
      },
      [openWithFaireAcademyFundingLicensingRoute]: {
        label: strictLocalize({
          id: "dUFhm6",
          defaultMessage: "Get funding & licenses",
          description: {
            text: "Breadcrumb for Open With Faire Academy Get funding & licenses Guide",
            img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
          },
        }),
      },
      [openWithFaireAcademyLayTheGroundworkRoute]: {
        label: strictLocalize({
          id: "lGFyTa",
          defaultMessage: "Lay the groundwork",
          description: {
            text: "Breadcrumb for Open With Faire Academy Lay the groundwork Guide",
            img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
          },
        }),
      },
      [openWithFaireAcademyOrganizeStoreOperationsRoute]: {
        label: strictLocalize({
          id: "G7n5o2",
          defaultMessage: "Organize your operations",
          description: {
            text: "Breadcrumb for Open With Faire Academy Organize your operations Guide",
            img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
          },
        }),
      },
      [openWithFaireAcademyPromoteYourStoreRoute]: {
        label: strictLocalize({
          id: "yJ5QML",
          defaultMessage: "Promote your store",
          description: {
            text: "Breadcrumb for Open With Faire Academy Promote your store Guide",
            img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
          },
        }),
      },
      [openWithFaireAcademyRenovateYourStoreRoute]: {
        label: strictLocalize({
          id: "bxixfl",
          defaultMessage: "Renovate your store",
          description: {
            text: "Breadcrumb for Open With Faire Academy Renovate your store Guide",
            img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
          },
        }),
      },
    };
    if (pathMatchesRoute(pathname, openWithFaireRoute)) {
      return [{ ...openWithFaireLanding, path: undefined }];
    }
    const breadcrumbOptions: IBreadcrumbOption[] = [openWithFaireLanding];
    if (pathMatchesRoute(pathname, openWithFaireAcademyRoute)) {
      breadcrumbOptions.push({
        ...openWithFaireFaireAcademyLanding,
        path: undefined,
      });
    }
    const faireAcademyGuideRoutes = Object.keys(
      faireAcademyGuidesBreadcrumbMap
    );
    const matchedRoute = faireAcademyGuideRoutes.find((route) =>
      pathMatchesRoute(pathname, route)
    );
    if (matchedRoute) {
      const breadcrumbOption = faireAcademyGuidesBreadcrumbMap[matchedRoute];
      if (breadcrumbOption) {
        breadcrumbOptions.push(openWithFaireFaireAcademyLanding);
        breadcrumbOptions.push(breadcrumbOption);
      }
    }

    return breadcrumbOptions;
  }, [pathname, strictLocalize]);
};
